module.exports = __webpack_public_path__ + "img/kv.b619ad3.jpg";